import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import { cloneDeep, has, keys, uniqueId, isEqual } from 'lodash';
import { store } from '../redux/store';
import { resetFormData as resetStartFormData } from '../redux/slices/application-start-slice';
import { resetFormData as resetStep1FormData } from '../redux/slices/application-step-1-slice';
import { resetFormData as resetStep2FormData } from '../redux/slices/application-step-2-slice';
import { resetFormData as resetStep3FormData } from '../redux/slices/application-step-3-slice';
import { resetFormData as resetStep4FormData } from '../redux/slices/application-step-4-slice';
import { resetFormData as resetStep5FormData } from '../redux/slices/application-step-5-slice';
import { resetAuthData, resetRetrieveFromMyInfo, resetSingPassAuthData } from '../redux/slices/authentication-slice';
import { resetStageA } from '../redux/slices/completed-steps-slice';
import moment from 'moment';

export class Helpers {

  static clearPersistData = async() =>{
    return new Promise(async (resolve, reject)=>{
      store.dispatch(resetStageA());
      store.dispatch(resetStartFormData());
      store.dispatch(resetStep1FormData());
      store.dispatch(resetStep2FormData());
      store.dispatch(resetStep3FormData());
      store.dispatch(resetStep4FormData());
      store.dispatch(resetStep5FormData());
      store.dispatch(resetRetrieveFromMyInfo(false));
      storage.removeItem('persist:app').then(res=>{
        console.log("---> CLEAR APPLICATION FORM DATA <----");
        resolve(true);
      });
    })
  }
  
  static clearAuthPersistData = () =>{
    store.dispatch(resetAuthData());
    storage.removeItem('persist:auth').then(res=>{
      console.log("---> CLEAR AUTH DATA <----");
    });
  }
  static clearSingpassAuthPersistData = () =>{
    store.dispatch(resetSingPassAuthData());
    storage.removeItem('persist:auth').then(res=>{
      console.log("---> CLEAR AUTH DATA <----");
    });
  }

  static formatDate(dateString?:string, monthType?:"short" | "long") {
    let monthFormatType = monthType ?? "long";
    if(!dateString){
      return "";
    }
    const date = new Date(dateString);
    if(dateString.includes(" ")){
      let parts = new Intl.DateTimeFormat("en-GB", {day:"2-digit", month: monthFormatType, year:"numeric", hour:"2-digit", minute:"2-digit", second:"2-digit", hour12:true}).formatToParts(date).reduce((acc:any, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});

      return `${parts.day} ${parts.month} ${parts.year}, ${parts.hour}:${parts.minute}:${parts.second}${parts.dayPeriod}`; 
    }
    return new Intl.DateTimeFormat("en-GB", {day:"2-digit", month: monthFormatType, year:"numeric"}).format(date);
  }
  static formatTime(timeString?:string) {
    if(!timeString){
      return "";
    }
    
    const formattedTimeString = moment(timeString, ["HH:mm:ss"]).format("hh:mma");
    return formattedTimeString;
  }
  
  static formatGetDayLeft(dateString:string) {
    if(!dateString){
      return 0;
    }
    let eventdate = moment(dateString);
    let todaysdate = moment();
    return eventdate.diff(todaysdate, 'days');
  }
  static formatGetDayAgo(dateString:string) {
    const daysLeft = this.formatGetDayLeft(dateString);
    if(daysLeft < 0){
      const daysAgo = Math.abs(daysLeft);
      return daysAgo;
    }
    else{
      return 0;
    }
  }


  static formatCurrencyInput(e:string, isBlur?:boolean):string{
    let currency = ""; //Remove dollar sign
    if(e.indexOf(".") >= 0){
      let decimal_pos = e.indexOf(".");
      let left_side = e.substring(0, decimal_pos);
      let right_side = e.substring(decimal_pos);

      // add commas to left side of number
      left_side = left_side.replace(/[^\d]+/g, "").replace(/[^\d](?=(\d{3})+(?!\d))/g, "$1,");
      if(!left_side){
        left_side = "0";
      }
      // validate right side
      right_side = right_side.replace(/[^\d]+/g, "").replace(/[^\d](?=(\d{3})+(?!\d))/g, "$1,");
      
      // On blur make sure 2 numbers after decimal
      if (isBlur) {
        right_side += "00";
      }

      right_side = right_side.substring(0, 2);
      return currency + left_side + "." + right_side;
    }
    else{
      let input_val = e.replace(/[^\d]+/g, "").replace(/[^\d](?=(\d{3})+(?!\d))/g, "$1,");
      if (isBlur) {
        if(input_val){
          //When have value, eg: 1, then add .00 to become 1.00
          input_val += ".00";
        }
        else{
          //When no value, eg: empty, then we don't add .00, else it will become 'SGD .00'
          return "";
        }
      }
      return currency + input_val;
    }
  }


  static generateAlphaNumericID (){
    return uniqueId();
  }


  static formatThousandSeparator(amount?:string | number, unit?: string){
    if(!amount){
      return '';
    }
    let value_unit = unit ?? "";
    if(Number(amount) >= 1000){
      return amount ? value_unit + amount.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",").replace(/(\.\d{4})\d*$/, "$1") : value_unit + amount; 
    }
    else{
      return value_unit + amount;  
    }
  }

  static formatStringToNumber(value?:string){
    if(!value){
      return 0;
    }
    if(typeof value === 'number'){
      return value
    }
    else{
      return parseFloat(value.replace(',', ''));
    }
  }

  static flattenNestedObj(object:any):any{
    return keys(object).reduce((result:any, fields:any, next)=>{
      const value = object[fields.toString()];
      if(has(value,'isValid')){
        return {...result,[fields.toString()]:value};
      }
      else{
        const testing:any = this.flattenNestedObj(value);
        return {...result, ...testing};
      }
    },{});
  }


  static formatDocumentListTitle(title:string = "", owner_name:string = "", address:string = ""){
    let tempTitle = title;
    if(tempTitle.includes("<<Name>>")){
      tempTitle = tempTitle.replace("<<Name>>", owner_name);
    }
    else if(tempTitle.includes("<<Address>>")){
      tempTitle = tempTitle.replace("<<Address>>", address);
    }
    return tempTitle;
  }

  static formatBytesToMB(size:number){
    let toFixedValue = 2;
    if(size <= 9999) //if greater thn 9999 bytes, to change the tofixed value.
    {
      toFixedValue = 3;
    }
    return (size/ (1024*1024)).toFixed(toFixedValue);
  }

  /**
   * 
   * @param size number in the bytes
   * @param exceedLimit number in the bytes
   * @returns 
   */
  static isBytesExceed(current_bytes:number, exceed_bytes:number):boolean{
    return current_bytes > exceed_bytes; //is size is greater to 5mb = 5000000=bytes
  }


  static stripBase64(base64?:string){
    if(base64){
      if(base64.includes(",")){
        return base64.split(",")[1];
      }
      else{
        return base64;
      }
    }else{
      return ""
    }
  }


  static stripMimeType(mime_type?:string){
    if(mime_type){
      let subString = mime_type.split("/");
      return subString[1];
    }
    else{
      return mime_type
    }
  }


  static maskContent(string?:string, enable:boolean = true){
    if(enable){
      return "***********";
    }
    else{
      return string;
    }
  }

  static maskPartialContent(string:string, enable:boolean = true){
    if(enable){
      const charactersLeft = 4;
      let lastFourChar = string.substring(string.length - charactersLeft, string.length);
      const maskedLength = string.length - charactersLeft;
      let resultString = "*".repeat(maskedLength) + lastFourChar;
      return resultString;
    }
    else{
      return string;
    }
  }


  static getYearFromDate = (date?: string) => {
    if(date){
      let regexPattern = /\d{4}-\d{2}-\d{2}$/
      
      if(regexPattern.test(date)){
        let dateArr = date.split("-");
        return dateArr[0];
      }
      else{
        return null;
      }
    }
    else{
      return null;
    }
  }


  static amountToTwoDecimals = (value: string | number | undefined) => {
    if (value === undefined || value === 0) {
      return "$0.00";
    }

    if (typeof value === "number") {
      return Helpers.formatThousandSeparator(value.toFixed(2), "$ ");
    }

    const amount = Helpers.formatThousandSeparator(value, "$ ");
    if (amount.includes(".")) {
      if (
        amount.substring(amount.indexOf(".") + 1, amount.length).length === 2
      ) {
        return amount;
      } else {
        return amount + "0";
      }
    } else {
      return amount + ".00";
    }
  }

  static replaceUndefinedWithEmptyString(obj:any) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === undefined) {
        obj[key] = '';
      }
    }
  }

  static checkIsValueChanged = (value:any, sliceValue:any) =>{
    const tempValue = cloneDeep(value);
    const tempSliceValues = cloneDeep(sliceValue);
    this.replaceUndefinedWithEmptyString(tempValue);
    this.replaceUndefinedWithEmptyString(tempSliceValues);
    return !isEqual(tempValue, tempSliceValues);
  }

  static replaceEmptyStringWithNull = (obj : any) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'string' && obj[key] === '') {
        obj[key] = null;
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        this.replaceEmptyStringWithNull(obj[key]);
      }
    }
  }
}